import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const collogApi = axios.create({
  baseURL: API_BASE_URL + "api/collectionlogfeed",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
